// @ts-nocheck
/* eslint-disable */
import { addDays, format, differenceInDays } from 'date-fns';
import { zonedTimeToUtc } from 'date-fns-tz';
import { DEFAULT_DATE_FORMAT_DATE_FNS } from '../../../main/support/Dates/dateUtils';

export const LIMIT_CONFIGURATION = {
  day: {
    maxDays: 30,
    sample: 7,
    sampleDisplay: '7 days',
    display: 'Day',
  },
  week: {
    maxDays: 60,
    sample: 14,
    sampleDisplay: '2 weeks',
    display: 'Week',
  },
  month: {
    maxDays: 90,
    sample: 30,
    sampleDisplay: 'month',
    display: 'Month',
  },
  all: {
    maxDays: 30,
    sample: 30,
    sampleDisplay: '30 days',
    display: 'All Time',
  },
};

export const shouldLoadPartialData = ({ granularity, start_date, end_date }) => {
  if (!LIMIT_CONFIGURATION[granularity]) {
    return false;
  }
  const loc = 'UTC';
  const start = zonedTimeToUtc(start_date, loc);
  const end = zonedTimeToUtc(end_date, loc);
  const { maxDays } = LIMIT_CONFIGURATION[granularity];
  const spanInDays = Math.abs(differenceInDays(start, end));
  return spanInDays > maxDays;
};

export const getSampleEndDate = ({ granularity, start_date, end_date }) => {
  if (!LIMIT_CONFIGURATION[granularity]) {
    return false;
  }
  const loc = 'UTC';
  const start = zonedTimeToUtc(start_date, loc);
  const { sample } = LIMIT_CONFIGURATION[granularity];
  const sampleEndDate = addDays(start, sample);
  return format(sampleEndDate, DEFAULT_DATE_FORMAT_DATE_FNS);
};
